module.exports = __webpack_public_path__ + "media/images/stories/256_rsz_clem-onojeghuo-193397-unsplash-c1c3b14fccc1c2053f762de444b1e27e.jpg";